import * as React from "react"
import type { SVGProps } from "react"
const SvgReply = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m6.83 12.71 2.9 2.9q.3.3.28.7a1 1 0 0 1-.31.7q-.3.28-.7.3a1 1 0 0 1-.7-.3l-4.6-4.6a1 1 0 0 1-.3-.7q0-.4.3-.7l4.6-4.6a1 1 0 0 1 .69-.27q.4 0 .71.27.3.3.3.72 0 .4-.3.7l-2.87 2.88H16q2.07 0 3.54 1.47A4.8 4.8 0 0 1 21 15.7v3q0 .44-.29.72a1 1 0 0 1-.71.28 1 1 0 0 1-.71-.28 1 1 0 0 1-.29-.72v-3q0-1.25-.87-2.12A3 3 0 0 0 16 12.7z" />
  </svg>
)
export default SvgReply
